export default __webpack_public_path__ + "beta-maps-guides-migrate-custom-render-1200-e0bf1f76d00e11a2786387c728e91e65.png";